import * as field from './transforms.fields';
import { SD, RG } from './constants';

/**
 * Extract donation form specific configs from appeal entity.
 */
export const getDonationFormConfig = (appeal) => ({
  appealId: field.getNumberValue(appeal, 'nid'),
  appealUrl: field.getEntityURL(appeal).url,
  title: field.getTextValue(appeal, 'title'),
  donationFormTitle: field.getTextValue(appeal, 'field_title'),
  minAmount: field.getNumberValue(appeal, 'field_donation_min_amount'),
  image: field.getImage(appeal, 'field_media_secondary_image', 'checkout_background'),
  styling: field.getTextValue(appeal, 'field_checkout_style') || 'normal',
  showFundraisingCosts: field.getBooleanValue(appeal, 'field_fundraising_costs'),
  headerTags:
    field.getTextValue(appeal, 'field_emergency_tag_label') &&
    (field.getTextValue(appeal, 'field_checkout_style') === 'emergency' ||
      field.getTextValue(appeal, 'field_checkout_style') === 'dec')
      ? [
          { label: 'Emergency', color: 'red', isUppercase: true },
          {
            label: field.getTextValue(appeal, 'field_emergency_tag_label'),
            color: 'black-emergency',
            isUppercase: true,
          },
        ]
      : null,
  sourceCodes: field.getArrayValue(appeal, 'field_source_codes').filter((code) => {
    if (!code.startsAt || code.startsAt <= Date.now() / 1000) {
      return true;
    }

    return false;
  }),
  sourceCodesRG: field.getArrayValue(appeal, 'field_source_codes_rg').filter((code) => {
    if (!code.startsAt || code.startsAt <= Date.now() / 1000) {
      return true;
    }

    return false;
  }),
  supportsSingle: !!field
    .getArrayValue(appeal, 'field_donation_type')
    .find((el) => el.value === SD),
  supportsRecurring: !!field
    .getArrayValue(appeal, 'field_donation_type')
    .find((el) => el.value === RG),
  extraFeatures: field.getArrayValue(appeal, 'field_donation_extra_features').map((el) => el.value),
  impactsSingleDonation: field.getArrayValue(appeal, 'field_impacts'),
  impactsMonthlyDonation: field.getArrayValue(appeal, 'field_impacts_monthly'),
  stepsData: {
    amount: {
      heading: field.getTextValue(appeal, 'field_step_amount_heading'),
      text: field.getTextValue(appeal, 'field_step_amount_text'),
    },
    address: {
      heading: '',
      text: '',
    },
    preferences: {
      heading: 'We need to stay in touch',
      text: '',
    },
    source: {
      heading: 'What motivated your contribution today?',
      text: '',
    },
    giftaid: {
      heading: 'Increase the value of my donation by 25% at no extra cost',
      text: '',
    },
    payment: {
      heading: '',
      text: '',
    },
  },
});
